var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolveDigitalSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1800 1500",
    id: "solve-digital-security",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 8841.472,
    x2: 8867.897,
    y1: 1136.536,
    y2: 1277.856,
    gradientTransform: "translate(-8426.191)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#299bd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1491d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 8871.419,
    x2: 8897.845,
    y1: 1130.937,
    y2: 1272.256,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 8615.501,
    x2: 8654.004,
    y1: 1072.553,
    y2: 1278.463,
    gradientTransform: "rotate(8.551 5164.96 -47329.7)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 754.065,
    x2: 791.41,
    y1: 1010.159,
    y2: 1209.874,
    gradientTransform: "scale(-1 1) rotate(-22.539 -114.518 6444.334)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 2004.823,
    x2: 2025.678,
    y1: -2750.827,
    y2: -2639.293,
    gradientTransform: "scale(-1 1) rotate(-68.345 3134.27 1768.049)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -580.623,
    x2: -467.638,
    y1: 1309.496,
    y2: 1326.651,
    gradientTransform: "matrix(-1 0 0 1 51.972 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 8646.441,
    x2: 8736.383,
    y1: 1315.513,
    y2: 1329.169,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 8931.415,
    x2: 8705.058,
    y1: 1328.422,
    y2: 1249.992,
    gradientTransform: "translate(-8426.191)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#3fa5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52aedc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 7497.069,
    x2: 7610.054,
    y1: 1309.496,
    y2: 1326.651,
    gradientTransform: "translate(-6349.779)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 548.633,
    x2: 638.576,
    y1: 1315.513,
    y2: 1329.169,
    gradientTransform: "matrix(-1 0 0 1 2128.384 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 8529.862,
    x2: 8742.456,
    y1: 1343.523,
    y2: 1209.789,
    gradientTransform: "translate(-7235.482)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1091.224,
    x2: 1123.395,
    y1: 1133.808,
    y2: 1065.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001f3e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 1095.608,
    x2: 1127.779,
    y1: 1135.872,
    y2: 1067.51,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 1183.944,
    x2: 1160.965,
    y1: 899.333,
    y2: 1050.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef6035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb3100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 17110.806,
    x2: 17110.806,
    y1: 3215.697,
    y2: 3666.303,
    gradientTransform: "scale(-1 1) rotate(-19.33 694.92 55838.451)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8b37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb8744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 17568.979,
    x2: 17568.979,
    y1: 3188.862,
    y2: 3643.481,
    gradientTransform: "scale(-1 1) rotate(-26.398 2969.49 42060.24)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 17557.027,
    x2: 17557.027,
    y1: 3191.986,
    y2: 3637.323,
    gradientTransform: "scale(-1 1) rotate(-26.398 2969.49 42060.24)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 702.732,
    x2: 676.881,
    y1: 1162.658,
    y2: 1078.211,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 713.922,
    x2: 688.071,
    y1: 1159.233,
    y2: 1074.786,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 607.133,
    x2: 640.836,
    y1: 910.276,
    y2: 1063.467,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 652.622,
    x2: 619.302,
    y1: 1049.015,
    y2: 919.185,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 658.833,
    x2: 625.514,
    y1: 1047.421,
    y2: 917.591,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 662.727,
    x2: 629.408,
    y1: 1046.421,
    y2: 916.591,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 906.029,
    x2: 906.029,
    y1: 679.699,
    y2: 790.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14b6c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 1070.453,
    x2: 923.892,
    y1: 881.776,
    y2: 881.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008ca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 1047.312,
    x2: 1047.312,
    y1: 644.987,
    y2: 779.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 1051.563,
    x2: 1051.563,
    y1: 801.488,
    y2: 895.988,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 847.732,
    x2: 847.732,
    y1: 941.082,
    y2: 819.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009eb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005c86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 917.396,
    x2: 958.896,
    y1: 850.563,
    y2: 885.063,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 906.028,
    x2: 906.028,
    y1: 771.231,
    y2: 848.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72d3de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14b6c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 887.203,
    x2: 949.094,
    y1: 728.23,
    y2: 780.743,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 890.323,
    x2: 890.323,
    y1: 747.103,
    y2: 844.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0095af",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095af",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 906.029,
    x2: 906.029,
    y1: 643.699,
    y2: 559.985,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 456.419,
    x2: 456.419,
    y1: 716.274,
    y2: 625.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0086a6",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0086a6",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 521.948,
    x2: 521.948,
    y1: 430.38,
    y2: 578.353,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 521.948,
    x2: 521.948,
    y1: 430.38,
    y2: 578.353,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 906.029,
    x2: 906.029,
    y1: 430.38,
    y2: 578.353,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 1290.109,
    x2: 1290.109,
    y1: 430.38,
    y2: 578.353,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 1290.109,
    x2: 1290.109,
    y1: 430.38,
    y2: 578.353,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 1290.109,
    x2: 1290.109,
    y1: 1006.571,
    y2: 794.417,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 906.029,
    x2: 906.029,
    y1: 1006.571,
    y2: 794.418,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 1290.109,
    x2: 1290.109,
    y1: 1006.572,
    y2: 794.418,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 521.948,
    x2: 521.948,
    y1: 1006.572,
    y2: 794.419,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 521.948,
    x2: 521.948,
    y1: 1006.572,
    y2: 794.418,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 1156.332,
    x2: 1021.524,
    y1: 1190.139,
    y2: 1266.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000427",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 1318.436,
    x2: 1213.936,
    y1: 961.59,
    y2: 1125.09,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 654.662,
    x2: 796.875,
    y1: 1185.951,
    y2: 1276.079,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 557.382,
    x2: 488.957,
    y1: 1085.244,
    y2: 942.776,
    xlinkHref: "#h"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "m1620.9501953,1358.9992898H179.050293c-11.0458984,0-20-8.9541016-20-20s8.9541016-20,20-20h1441.8999023c11.0458984,0,20,8.9541016,20,20s-8.9541016,20-20,20Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m371.4371578,1150.8877102c-12.368,12.9109,11.672,47.0441,53.6187,56.3921-1.8569-32.8136-35.0027-75.8222-53.6187-56.3921Zm73.3614,139.649l7.0869-6.535c-10.7929-21.5832-20.0602-47.0054-25.1508-76.1209,46.4854-33.4545,48.1943-76.767,30.784-84.9687-17.2194-8.1109-42.4369,17.423-43.5643,49.4323-.1843.5358-.2733,1.1127-.2432,1.7121,1.0773,21.5845,4.4947,42.7058,10.1871,63.133.0003.0008.0007.0017.0009.003,1.1276,4.4019,3.2339,11.6108,4.7414,15.294.0003.0002,0,.0006.0003.0008,2.266,6.6443,4.7633,13.21,7.5235,19.6821,2.6481,6.2075,5.5374,12.3313,8.6342,18.3673Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m448.6421578,1254.4644102c-5.0674-31.4986,11.8765-57.4501,24.1769-52.4636,18.5121,7.5064-2.0538,42.175-24.1769,52.4636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m1448.3954363,1067.4865102c-11.7569997-13.1477-30.6742992.3-43.1551989,20.3438-.0266-.1203-.0389-.2449-.0747-.3617-.0261-32.0293-24.3505994-58.4153-41.8387795-50.9011-17.682,7.5982-17.463319,50.9438,27.8441799,85.977-6.0887998,28.9233-16.2245996,54.0117-27.7535993,75.2109-21.4208995,42.8087-45.6269988,78.8648-45.6269988,78.8648l9.6448998,1.4506s23.1266994-34.4503,44.1740989-75.9817c2.8020999-5.138,5.4578999-10.3416,7.9268998-15.6183,2.9809999-6.3734,5.7026999-12.8493,8.1955998-19.4118.0006-.0002.0001-.0005.0006-.0007,1.6331-3.6293,3.9860999-10.7614,5.2643999-15.122.0002-.0012.0005-.0022.0009202-.0029,3.2931798-10.4178,5.9776797-21.0437,8.066-31.8402,37.2322787-10.3407,58.4553782-40.1651,47.3316784-52.6067Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m1320.7038395,1170.0706102c18.7563995.1539,26.8156993,43.2056,3.1396999,81.5752-23.3037816-25.4128-31.3689992-81.8047-3.1396999-81.5752Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m1422.2632369,1150.7022102c7.2397998,7.5703-6.8616998,27.5562-31.4418992,33.012,1.1043-19.2236,20.5448995-44.4049,31.4418992-33.012Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m515.0164578,1338.9993342c27.6519-48.8322241,82.93763-66.2794241,109.426-38.952799,11.9817,12.3602997,11.2125,26.5980993,6.2961,38.952799h-115.7221Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m313.8489578,1338.9993342c-22.0125-38.873099-66.023-52.7621241-87.1093-31.0085992-9.538,9.8394998-8.9257,21.1735995-5.012,31.0085992h92.1213Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m555.6970578,1279.4728102c-14.3207-42.8235-71.5036-44.3172-104.9985,1.7082-3.0838-6.364-6.6198-12.8698-10.6772-19.4962-49.5714-80.9528-144.2648-81.7824-167.1436-13.3671-9.7989,29.2982-.246,62.4019248,13.8765,90.6816241h259.8337c9.2705-18.5636995,15.5414-40.2942241,9.1091-59.5265241Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m1264.8686409,1338.9993342c-27.6518831-48.8322241-82.9376979-66.2793241-109.4260972-38.952699-11.9815997,12.3601997-11.2123997,26.5979993-6.2959998,38.952699h115.7220971Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m1486.1515353,1338.9993342c22.0123994-38.873099,66.0229983-52.7621241,87.1092978-31.0085992,9.5379998,9.8395998,8.9256998,21.1735995,5.0119999,31.0085992h-92.1212977Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "m1526.4935343,1233.4859102c-26.4731993-79.1636-140.6011964-80.8467-193.4026951,15.4671-3.2061999,5.8485-6.2083998,12.03-8.9875998,18.3519-41.0874816-45.604-103.0166974-30.1792-107.4398973,16.3622-1.8989,19.973425,9.0032998,39.5141245,22.0884994,55.3322241l271.6849931-.5853c16.3413996-32.7225992,27.3949993-71.0271241,16.0566996-104.9281241Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f5ab74",
    d: "m992.3559478,816.2268102c-.0244-3.3242-.9395-13.6055-3.5829999-13.5752-6.2626998.0645-2.6679999,5.6797-6.8798998,12.374-2.7216999,4.3233,6.8974998,14.3536,6.8974998,14.3536,0,0,3.6337999-6.2207,3.5653999-13.1524Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5ab74",
    d: "m1074.0258457,880.9094102c-17.7333996-19.3984-76.2440879-45.8427-83.3016979-56.0078-4.5829999-6.6015.5859-12.9336-11.8369997-21.8818-6.0213903-4.336-23.5506994,6.2734-21.6913903,13.4619,4.252,16.4521,13.9658905,19.6104,25.6621902,17.3164,6.7020998,2.2734,53.5096986,46.4902,67.5731983,57.8399,6.3466998,5.123,16.3798996,12.125,21.0712995,8.5947,7.4745998-5.6172,9.1034998-12.1211,2.5233999-19.3233Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f5ab74",
    d: "m1094.7778452,877.2327102s-26.1171993,3.9326-33.6288992,6.5078c-5.3886999,1.8359-2.2333999,9.1074-.3614,13.5937,1.8711,4.4815,19.4922118,8.833,34.7714991,7.5821,11.7011997-.9571,1.3145-26.7403-.7812-27.6836Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14b6c8",
    d: "m1177.1176431,870.8743102c-21.8632994-1.8858-97.0702975,3.6748-97.0702975,3.6748,0,0-4.0683999,6.0166-4.0604999,20.2617.0214,21.3916,5.9979998,28.4629,5.9979998,28.4629,18.7636995,2.1738,12.7030997,1.1934,51.3241987,4.7773,26.3964993,2.4483,56.0243986-56.1269,43.8085989-57.1767Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m1173.5532432,830.7385102c-7.8066998-10.9209-4.4570999-39.5332,11.0370997-41.3877,19.1405995-2.2949,16.1678996,16.0586,26.4198993,18.9278,22.2987994,6.25,24.5565994,21.876,17.1601996,38.084-4.5800999,10.039-15.9550996,17.6543-26.7148993,19.5498-4.6737847.8242.166-17.5645-9.6464998-26.2139-9.8124998-8.6611-18.2557995-8.96-18.2557995-8.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m1094.3032452,1023.0149102s-29.5214874,104.2695-34.5761991,125.3848c-5.0526999,21.1152,33.5624992,37.4843,52.6600987,13.9511,19.1074995-23.5195,44.9550989-56.4863,53.3144987-83.7695,8.3476998-27.2871,8.0741998-50.1074-6.7694998-72.209-14.8339996-22.0996-56.7050986-11.459-64.6288984,16.6426Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#030126",
    d: "m1204.3071424,1330.4426344s32.2401992-8.1581998,34.5897991-8.8885998c2.6015999-.8086,6.7050998-2.2636999,7.1698998,6.2557998.4512,8.5214998.7559164,11.1894997.7559164,11.1894997,0,0-37.3008155-.0586-41.3145154-.5274-4.0086999-.4746-7.1659998-3.5038999-1.2011-8.0292998Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5ab74",
    d: "m1241.0454415,1323.1672346s-8.3808998-21.3202995-10.1298997-36.8867245c-.6866-6.1777-4.0849999-24.7851-8.2021998-46.1425l-28.1093993,11.496c17.2539996,34.3965,37.888699,75.7129244,37.888699,75.7129244,0,0,2.9648999,1.3536,5.3437999.0606,3.5741999-1.9395,3.2089999-4.2402999,3.2089999-4.2402999Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m1205.9584424,1157.6497102c-4.2801999-18.6328-13.9305996-30.8633-34.6678991-24.2578-20.7333995,6.6132-27.2743993,19.6933-22.3193994,30.2441,11.3124997,24.0742,13.0283997,23.4102,27.5693993,52.1113,4.2782999,8.4395,10.8768997,21.5625,18.0633995,35.8867l28.1093993-11.496c-6.2548998-32.4473-14.1659996-71.2442-16.7548996-82.4883Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#030126",
    d: "m980.1313481,1306.538335s30.6386992,12.9316997,32.9520992,13.7636997c2.5634999.9258,6.7158998,2.2382999,1.9483106,9.3144998-4.7754105,7.0702998-6.1426105,9.3827998-6.1426105,9.3827998,0,0-29.7216992-22.5370994-32.6405992-25.3320994-2.9130999-2.7948999-3.6054999-7.1171247,3.8827999-7.1288998Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f5ab74",
    d: "m1012.0063473,1323.2102346s9.1991998-20.9804995,18.9999995-33.1992245c3.8944999-4.8457,14.6854996-20.3809,26.9198993-38.3652l-27.9765993-11.8145c-12.208889,36.4942-26.9393993,80.2656245-26.9393993,80.2656245,0,0,1.1328,3.0546999,3.7265999,3.8281755,3.8963999,1.166,5.2694999-.7148755,5.2694999-.7148755Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "m1104.5786449,1181.5852102c10.1854997-16.1797,12.0458997-31.6465-7.2617998-41.6855-19.3153995-10.0313-33.1991992-5.4414-37.1835991,5.5136-9.0838998,25-7.4002998,25.7481-17.4881996,56.3008-2.9648999,8.9844-7.6113998,22.9199-12.6953997,38.1172l27.9765993,11.8145c18.5878995-27.3203,40.505899-60.2969,46.6523988-70.0606Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14b6c8",
    d: "m1022.879347,1255.0422102c-.1464.5293.1426,1.1485.6446,1.3731l24.9432994,11.2168c.5039.2266,1.1895115.0547,1.5254-.3809l10.6894997-13.8125c.3359-.4355.2011-.9746-.3008-1.1992l-31.7343992-14.2695c-.5019-.2246-1.031189.0215-1.1797.5527l-4.5878999,16.5195Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m1139.3032441,1026.8059102c-5.4921999,48.8848,7.5838998,109.6035,8.6307998,131.291,1.0449,21.6856,42.6952989,26.6153,54.4589986-1.3144,11.7743997-27.9219,27.3887153-66.793,27.7929993-95.3262.3945-28.5332-6.2421998-50.3711-26.6679993-67.4453-20.4179995-17.0723-59.9550985-5.1113-64.2147984,32.7949Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m1185.2348429,869.8528102c-33.7226991-5.25-43.3417989,22.8144-53.2167987,46.2812-22.8241994,54.2149-43.2772864,120.3165-43.2772864,120.3165,0,0,10.8924873,22.8515,63.4960859,35.4785,68.3124983,16.3886,79.947198-1.3243,79.947198-1.3243,0,0,8.8710998-76.0898,11.4687997-151.9863.5859164-17.082-9.7187998-35.3164-36.3007991-43.8789-7.5858998-2.4394-13.7987997-3.5976-22.1171994-4.8867Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m1167.0297578,868.5852102c-4.0605143,9.3867-15.824214,29.4746,7.7948854,33.5762,27.7441993,4.8281,40.051799-22.207,39.2481146-25.7617-1.8262156-8.0918-13.6387153-6.5742-20.6621151-7.6992-7.0194998-1.1172-22.9394994-8.0743-26.3808849-.1153Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m1206.9965424,874.2063102c-1.3027-.4082-2.6268999-.7949-4.0175999-1.1601-7.7167998-1.9922-13.9862996-2.7813-22.3573994-3.5821-2.6385999-.2558-5.1132999-.3047-7.4335998-.166-2.2928999,6.1777-12.5956997,22.3867,5.0761999,25.9707,18.1464995,3.6758,27.7479993-14.8633,28.7323993-21.0625Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "m1198.2270426,879.0305102c5.4745999-17.625,4.7655999-29.5752,3.3134999-45.5644-3.7841999-6.4815-14.3017847-.3614-19.3193995-13.0088-1.6621-4.1895-5.3807999-3.2481-6.9764998.2558,0,0-4.5312999,10.8497-5.9824998,23.3448-1.3769,11.789.1915,18.8554,12.7617997,16.6845-2.3476999,4.9727-5.3476999,10.9766-8.0605998,15.1954-5.4618999,8.5136-.6738,14.121,3.6934146,16.1054,4.375,1.9795,15.0077849,4.9112,20.5702848-13.0127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "m1212.0161422,841.1594102c.8554,3.1631-2.2382999,6.751-6.9179998,8.0205-4.6718999,1.2579-9.1601998-.2802-10.0146997-3.4365-.8545-3.167,2.2373152-6.751,6.9228998-8.0146,4.6737999-1.2715,9.1561998.2744,10.0097997,3.4306Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#14b6c8",
    d: "m1200.3969425,1267.3762102c.2735.4766.916.7071,1.4297.5118l25.5448994-9.7696c.5156-.1953.877-.8047.8067-1.3496l-2.2499999-17.3203c-.0723-.5449-.5489-.8301-1.0624841-.6328l-32.502,12.4277c-.5117151.1973-.7109151.7481-.4394151,1.2266l8.4725998,14.9062Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m705.080555,907.3411102s22.6649994,13.3838,28.6444993,18.5703c4.2929999,3.7109-1.3408,9.2471-4.7460999,12.6973-3.4051966,3.4453-21.3065995.8837-34.9588966-5.9815-10.4493-5.2588,8.7733973-25.1953,11.0604972-25.2861Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14b6c8",
    d: "m635.4164578,875.5549102c27.0479,6.2002,81.3085969,33.335,81.3085969,33.335,0,0-.373,4.9717-5.6971999,18.1299-8.0058998,19.7529-19.1581971,26.4912-19.1581971,26.4912,0,0-20.2569-5.7041-44.8516-14.0928-16.7187-5.7002-31.3857-17.1582-37.8535-36.3789-4.59571-13.665,5.9766-32.1318,26.2519-27.4844Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m749.9799539,825.5452102c-1.7197-2.8467-6.3251961-12.0821-4.0565999-13.4453,5.3680999-3.2207,5.2470999,3.4414,12.3407997,6.9414,4.5800999,2.2578,1.6387,15.8418,1.6387,15.8418,0,0-6.3554998-3.4004-9.9228997-9.3379Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m714.2602548,923.4124102c4.9530999-25.8096,40.958999-78.9766,41.6493989-91.3321.4473-8.0224-7.2694998-10.7119-1.3701-24.8427,2.8583999-6.8438,23.3495994-6.9815,25.5282994.1152,4.9911999,16.2461-1.6338,24.0176-12.7997997,28.1885-4.5184999,5.4482-21.2499995,67.624-27.2890993,84.6562-2.7245999,7.6934-8.0213998,19.8506-13.8670996,19.2998-9.3085998-.874-13.6865997-6.5058-11.8515997-16.0849Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "m701.0883551,1014.1477102s30.8915992,103.4863,36.2314991,124.4551c5.3299999,20.9707-32.9130964,37.8281-52.2783964,14.6484-19.371-23.166-45.5957-55.6523-54.3125-82.7187-8.707-27.0723-8.7558-49.8203,5.7168-72.0508,14.4747-22.2305,56.3477-12.2227,64.6425973,15.666Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#030126",
    d: "m774.4018533,1330.5901102s-32.0956992-8.2538755-34.4345991-8.9921755c-2.5829999-.8144-6.6708998-2.2811999-7.1639998,6.2089998-.4854,8.4882998-.794,11.1483997-.794,11.1483997,0,0,37.1659991.084,41.168999-.3691,3.9950999-.457,7.1551998-3.4648999,1.2236-7.9961241Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m744.423354,1324.5022346s-1.9278,2.6093999-4.6249999,2.6347999c-4.0487999.041-4.8417999-2.1386999-4.8417999-2.1386999,0,0-3.0194999-22.6327994-9.0282998-37.0391244-3.2451999-7.7578-13.2206997-37.8828-22.5566994-66.8818l36.4970991-3.1894c1.6191037,39.6396,4.5546999,106.6142244,4.5546999,106.6142244Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "m703.8871551,1125.9094102c21.2666995-4.2714,33.2978992,3.9571,34.0839991,15.5489,1.7891,26.4453-.0243964,26.6972,1.1944,58.7402.1787,4.7422.4218,10.8066.7031,17.6895l-36.4970991,3.1894c-7.9882998-24.8164-15.5116973-48.8105-17.9471973-57.2578-5.2852-18.3047-2.7969-33.6328,18.4627973-37.9102Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14b6c8",
    d: "m702.4809551,1229.4172102c.1484.5293.7187.9161,1.2676.8614l37.970699-3.9063c.5478-.0566.9951-.5527.9951-1.1015v-9.75c0-.5508-.4473-.9571-.9951-.9024l-41.257799,4.0547c-.5469.0527-.8731.5313-.7246,1.0606l2.7440999,9.6835Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m653.2407578,1026.2786102s-.9746,119.5-1.5957,140.6836c-.6309,21.1758-41.1739,26.7539-53.17973-.2793-11.99804-27.0371-37.61427-81.4141-31.78907-144.3184,3.1533-34.0195,86.2637-24.5781,86.5645,3.9141Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#030126",
    d: "m540.3871578,1316.9934348c-1.6396-2.1600999-4.1298-5.7255999-9.4365.9209-5.2968,6.6484998-7.0859,8.6532998-7.0859,8.6532998,0,0,8.8848,6.4316998,17.5937,12.4316997h17.4043c-6.3593-7.9999998-17.4238-20.6230995-18.4756-22.0058994Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#030126",
    d: "m563.1342578,1330.8323344s-10.5566-2.8749999-14.4648-3.9335999l-6.5039,12.0116997c9,.0723,17.8037.0879,19.6425-.0976,4.002-.4082,7.1993-3.3749999,1.3262-7.9804998Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m535.6069578,1320.1370347s11.2519-19.8691995,15.1562-34.9805245c2.374-9.2363,15.208-46.6406,26.3926-78.3935l35.7197,18.414c-19.4902,27.9326-69.415,100.2803244-69.415,100.2803244,0,0-3.1113.918-5.2793-.6914-3.2549-2.4101999-2.5742-4.6288999-2.5742-4.6288999Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m593.3823278,1161.7258102c6.83105-17.7851,18.06543-28.5039,37.59863-19.0859,19.5332,9.4277,24.1621,23.2461,17.793,32.9648-14.5293,22.1719-16.1289,21.2754-34.4942,47.5586-.4472.6407-.9199,1.3164-1.4043,2.0137l-35.7197-18.414c7.1152-20.2012,13.56348-38.1192,16.22657-45.0372Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14b6c8",
    d: "m572.5913578,1209.9485102c-.1778.5215.0722,1.1621.5546,1.4277l37.2041,20.3711c.4825.2637,1.1329.1094,1.4454-.3437l5.5332-8.0293c.3125-.4512.1738-1.041-.3067-1.3067l-39.9951-22.1132c-.4805-.2676-1.0195-.0586-1.1973.4628l-3.2382,9.5313Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "m617.8852578,874.7708102c33.707-4.5274,40.9473,25.0039,50.2969,48.5918,21.6054,54.4941,46.212897,128.1132,46.212897,128.1132,0,0-8.5839998,17.8711-67.853597,25.3262-69.4619,8.7363-79.6279-2.9902-79.6279-2.9902,0,0-10.8086-96.5567-9.7988-145.418.3564-17.0332,11.9668-41.2383,38.631824-49.2168,7.609376-2.2715,13.824176-3.2949,22.138676-4.4062Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m626.2465578,838.3977102c8.4551-11.2812,5.7403-42.0996-10.3926-44.9062-19.933548-3.4707-17.33003,16.3379-28.11812,18.8672-23.46678,5.5117-26.25388,22.125-18.97268,39.875,4.5098,10.9921,16.1836,19.75,27.370143,22.3515,4.861327,1.1289.308597-18.8183,10.798857-27.5625,10.4863-8.7539,19.3144-8.625,19.3144-8.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "m631.7368578,875.2962102c3.8496,9.4375,15.1503,29.6972-8.4668,33.2929-27.744179,4.2305-39.4424-22.9648-38.5694-26.4883,1.99026-8.0253,13.72756-6.2656,20.749-7.2402,7.0176-.9668,23.0254-7.5644,26.2872.4356Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m591.7983378,880.0637102c1.30469-.3808,2.632815-.7402,4.026369-1.0742,7.730471-1.8223,13.994151-2.4785,22.349651-3.0996,2.6386-.2031,5.1035-.1992,7.4121-.0117,2.1543,6.2031,12.082,22.5683-5.5996,25.7695-18.15824,3.2852-27.33891-15.3887-28.18852-21.584Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m594.5444338,880.6594102c.690127-17.5972-.562496-27.3535,1.491211-43.2226-.126953-.543,22.720713-2.2735,25.619113-14.8008,0,0,5.1524,14.0723,6.1231,26.5723.9258,11.7929-.9043,18.7695-13.3379,16.1328,1.3926,5.5273,3.957,11.9023,6.0293,16.4531,4.1621,9.1777-1.3613,14.0215-5.9531,15.3516-4.5957,1.3242-20.58408-.8722-19.971724-16.4864Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "m631.5688578,905.3567102l-.6055,10.6055-7.5332,2.4668-9.6933-10.8985s10.8925-7.7793,17.832-2.1738Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m629.5082578,912.5208102l41.125,97.3984c1.0704,2.5332,1.7168,6.8438,1.4356,9.5801l-3.7285,36.4531c-.2793,2.7344-1.9141,3.2148-3.6309,1.0664l-22.1601-27.7363c-1.7168-2.1485-3.4512-6.1328-3.8555-8.8516l-15.3047-102.8828c-.4043-2.7187-.4824-6.4141-.1699-8.2109l6.289,3.1836Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m584.8413578,848.3567102c-.9747,3.1172,1.97261,6.8066,6.58198,8.248,4.606447,1.4317,6.54004-.2441,7.51074-3.3554.96875-3.1211.62305-6.4922-3.997066-7.9297-4.605464-1.4434-9.130864-.0723-10.095654,3.0371Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "m1057.5454461,665.3977102h-303.0332923c-5.7030999,0-10.3690997,4.6651-10.3690997,10.3672v121.2178c0,3.8506,3.1493999,7,6.9999998,7h309.7714922c3.8495999,0,6.9999998-3.1494,6.9999998-7v-121.2178c0-5.7021-4.6679999-10.3672-10.3690997-10.3672Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "m1065.0825459,812.4827102h-147.8867881c-3.850508,0-7,3.1504-7,7v51.1201c10.25,0,15.3437917-12.0244,29.0410913-12.0244h.0127c.4404-.0244.8857-.041,1.3359-.041,12.8319997,0,23.2391994,10.4043,23.2391994,23.2392,0,12.8311-10.4071997,23.2393-23.2391994,23.2393-.3233,0-.6455-.0117-.9678-.0274-.1268913.0069-.2461.0274-.3808.0274-13.6972997,0-18.7910913-12.0283-29.0410913-12.0283v51.082c0,3.8506,3.149492,7,7,7h144.5175882c5.7011999,0,10.3691997-4.667,10.3691997-10.3672v-121.2197c0-3.8496-3.1503999-7-6.9999998-7Z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m1059.9145461,751.1546102c-2.2099999,0-3.9999999-1.7911-3.9999999-4v-4.9356c0-2.209,1.79-4,3.9999999-4,2.2089999,0,3.9999999,1.791,3.9999999,4v4.9356c0,2.2089-1.791,4-3.9999999,4Zm0-18.9356c-2.2099999,0-3.9999999-1.791-3.9999999-4v-20c0-2.209,1.79-4,3.9999999-4,2.2089999,0,3.9999999,1.791,3.9999999,4v20c0,2.209-1.791,4-3.9999999,4Zm0-34c-2.2099999,0-3.9999999-1.791-3.9999999-4v-16.8213h-21.2050995c-2.2089999,0-3.9999999-1.791-3.9999999-4s1.791-4,3.9999999-4h22.8359994c3.5116999,0,6.3690998,2.8565,6.3690998,6.3672v18.4541c0,2.209-1.791,4-3.9999999,4Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "m1064.082546,888.9876102c-2.2099999,0-3.9999999-1.7911-3.9999999-4v-3.543c0-2.209,1.79-4,3.9999999-4,2.2088999,0,3.9999999,1.791,3.9999999,4v3.543c0,2.2089-1.7911,4-3.9999999,4Zm0-17.543c-2.2099999,0-3.9999999-1.791-3.9999999-4v-18c0-2.209,1.79-4,3.9999999-4,2.2088999,0,3.9999999,1.791,3.9999999,4v18c0,2.209-1.7911,4-3.9999999,4Zm0-32c-2.2099999,0-3.9999999-1.791-3.9999999-4v-10.9619h-21.0390995c-2.2089999,0-3.9999999-1.791-3.9999999-4s1.791-4,3.9999999-4h25.0390994c2.2088999,0,3.9999999,1.791,3.9999999,4v14.9619c0,2.209-1.7911,4-3.9999999,4Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "m932.2514493,858.5374102c-.4502,0-.8955.0166-1.3369.041h-.0137c-13.6971997,0-18.7909995,12.0244-29.0389993,12.0244v-51.1201c0-3.8496-3.1503999-7-6.9999998-7h-147.8867963c-3.8504999,0-6.9999998,3.1504-6.9999998,7v121.2197c0,5.7002,4.6660999,10.3672,10.3691997,10.3672h144.5165963c3.8505999,0,6.9999998-3.1494,6.9999998-7v-27.582h.001v-23.5c10.2479997,0,15.3417996,12.0283,29.0389993,12.0283.1348,0,.2559085-.0205.3828-.0274.3223.0157.6426.0274.9678.0274,12.8310997,0,23.2373085-10.4082,23.2373085-23.2393,0-12.8349-10.4062088-23.2392-23.2373085-23.2392Z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "m946.0551489,879.3225102c-1.5029,0-2.9423911-.8506-3.6229999-2.3008-1.3037-2.7763-3.7128999-4.9277-6.6103912-5.9033-2.0937086-.7041-3.2197085-2.9726-2.5156085-5.0664.7041-2.0937,2.9716999-3.2217,5.0663999-2.5156,4.9560999,1.667,9.0752087,5.3428,11.3007997,10.0859.9385,1.999.0791,4.3819-1.9209,5.3203-.5488.2579-1.1279.3799-1.6973.3799Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m944.939949,776.1448102c0-21.4902-17.4208996-38.9121-38.912099-38.9121-21.4902995,0-38.911199,17.4219-38.911199,38.9121,0,14.7471,8.2051069,27.5771,20.2978995,34.1767v30.5323c0,9.2832,7.5956998,16.8789,16.8798996,16.8789h3.4676999c9.2832998,0,16.8798996-7.5957,16.8798996-16.8789v-30.5323c12.0927997-6.5996,20.2978995-19.4296,20.2978995-34.1767Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m904.29335,850.2307102c-5.1786999,0-9.3768998-4.1982-9.3768998-9.3769v-34.9844l-3.9071999-2.1328c-11.6388997-6.3518-18.2020995-19.4023-15.9514925-32.8582,2.4562929-14.6857,15.2428925-25.741,30.1274922-26.1327,17.7035996-.4659,32.2526992,13.7998,32.2526992,31.3991,0,11.5019-6.2801914,22.0742-16.3905996,27.5918l-3.9071999,2.1328v34.9844c0,5.1787-4.1981999,9.3769-9.3768998,9.3769h-3.4698999Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "m931.8295493,771.5325102c-1.0341,0-1.9794999-.6885-2.2626999-1.7344-.2783-1.0351-.6308-2.0625-1.0468-3.0547-.501-1.1933.0605-2.5674,1.2539-3.0683,1.1953-.501,2.5682999.0605,3.0692999,1.2548.4971,1.1836.917,2.4102,1.251,3.6475.3379,1.25-.4024,2.5361-1.6524,2.8731-.205.0556-.4100915.082-.6123.082Zm-4.9764999-9.7715c-.6856,0-1.3642916-.2988-1.8272-.874-3.0868999-3.834-7.1864998-6.6182-11.8563997-8.0528-1.2373-.3798-1.9326-1.6914-1.5528-2.9287.3799-1.2373,1.6905-1.9345,2.9287999-1.5527,5.5693081,1.71,10.4559997,5.0273,14.1327996,9.5937.8115084,1.0088.6523,2.4844-.3564916,3.2959-.4336084.3497-.9531084.5186-1.4687084.5186Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "m874.6186508,776.1448102c0,11.5019,6.2802998,22.0742,16.3905996,27.5918l3.9071999,2.1328v34.9844c0,5.1787,4.1981999,9.3769,9.3768998,9.3769h.6778c-3.1493922,0-5.7128999-4.206-5.7128999-9.3769v-34.9844l-2.3817999-2.1328c-6.1591998-5.5176-9.9862997-16.0899-9.9862997-27.5918,0-17.3193,8.5848998-31.4102,19.1376995-31.4102-17.3193996,0-31.4091992,14.0909-31.4091992,31.4102Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m744.413554,943.1077102c.8809-3.2051,4.4189999-12.9014,6.9648998-12.1905,6.0331998,1.6788,1.1123039,6.1758,3.4530999,13.7315,1.5137,4.8779-10.3691997,12.0859-10.3691997,12.0859,0,0-1.9043-6.9472-.0488-13.6269Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m648.8149578,984.5188102c22.1396-14.1641,85.4940965-24.6103,94.9354962-32.6084,6.1318998-5.1953,2.7724999-12.6474,17.0839996-18.0859,6.9364998-2.6348,21.1337995,12.1396,17.4823996,18.6045-8.3553998,14.7968-18.5555995,15.3408-29.2626993,10.1064-7.0614998.4668-63.6971961,31.1026-80.2127961,38.4385-7.4542,3.3105-18.9551,7.4863-22.5762,2.8642-5.7715-7.3554-5.6651-14.0595,2.5498-19.3193Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f4ad7d",
    d: "m645.6664578,966.8567102s13.543,22.5703,16.3262,29.9805c2.0059,5.3066-5.5879,7.4883-10.2226,8.8965-4.6329,1.4062-19.1504-9.379-27.8829-21.9219-6.6777-9.6035,19.7286-17.9629,21.7793-16.9551Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14b6c8",
    d: "m596.8032178,906.1047102c20.81834,18.3438,60.27544,70.3711,60.27544,70.3711,0,0-2.0567,6.9493-13.0079,15.9747-16.457,13.5468-25.6855,13.4394-25.6855,13.4394,0,0-23.00391-21.6152-40.625-40.709-11.9814-12.9824-13.8213-20.9414-11.9326-42.1152,1.7617-19.7383,15.3652-30.7129,30.97556-16.961Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f5ab74",
    d: "m1045.5395464,934.2268102c-1.4043-3.0127-6.5106998-11.9834-8.9023998-10.8574-5.6678999,2.6621-.0653888,6.2754-1.1132,14.1152-.6778,5.0625,12.2411997,10.1866,12.2411997,10.1866,0,0,.7187-7.169-2.2255999-13.4444Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5ab74",
    d: "m1146.7084439,959.0999102c-24.1932994-10.2696-88.4022978-9.9942-99.0458975-16.3047-6.9129998-4.0996-4.8446999-12.0069-19.8631995-14.9805-7.2792998-1.4394-18.8105891,15.4971-14.1318996,21.2608,10.7079997,13.1953,20.8554995,12.0292,30.5390992,5.081,7.0409998-.7187,67.9950983,20.0352,85.5028978,24.5107,7.9023998,2.0206,19.9394995,4.2178,22.7383135-.9443,4.4618858-8.2158,3.2392858-14.8076-5.7393139-18.623Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f5ab74",
    d: "m1160.1684435,946.5188102s-21.4921995,15.3486-27.0194993,21.0527c-3.9687999,4.0791,2.1415999,9.126,5.8436999,12.2774,3.6991999,3.1465,21.3788995-.9658,34.4277991-9.0108,9.9959997-6.163-10.9540997-24.4277-13.2519997-24.3193Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14b6c8",
    d: "m1225.8217578,905.6516102c-19.6611154,9.7471-79.9961139,45.1553-79.9961139,45.1553,0,0-.8974,7.2061,5.5693999,19.8994,9.7207141,19.0557,18.2538995,22.6465,18.2538995,22.6465,17.7089996-6.5713,11.8651997-4.6973,47.9110988-19.0186,24.6357157-9.789,22.3622994-75.6728,8.2617157-68.6826Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "m1035.8002467,582.4417102c-.0194889-64.6621-48.6571988-118.1348-111.2616972-125.8536-5.1278999-.6308-10.4315997-1.123-15.7264996-1.123h-2.9570999l-2.7831922.0498c-5.2949076-.001-10.5117075.3564-15.6396074.9893-62.6044984,7.7168-111.1982972,61.2607-111.2177972,125.9248l-.0127,83.0361h38.569299l.002-82.9941c.0098055-44.0704,32.4862992-80.7393,74.7284981-87.2862,4.4237999-.6855,8.9569998-1.0508,13.5703074-1.0498l2.7831922.0283,2.9570999-.0717c4.6131999-.001,9.3202998.2993,13.7440997.9848,42.2421989,6.5459,74.7186981,43.3272,74.7284981,87.3994l.002,82.9893h38.569299l-.0557-83.0234Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#14b6c8",
    d: "m1268.9633408,643.9651102c0-2.2227,1.8252-4.0381,4.0478999-4.0361l111.1435171.1709c2.22558.0068,4.043,1.8271,4.03808,4.0517l-.1094,72.2588c-.0068,2.2276-1.832,4.042-4.0545999,4.042l-111.1406972-.1748c-2.2245999-.0059-4.0399999-1.8252-4.0399999-4.0498l.1152-72.2627Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m1384.4614379,640.1340102l-55.0673986,45.5118c-1.2988,1.0713-3.5673999,1.0664-4.8583999-.0059l-53.9550986-44.8769c-.9736.7402-1.6152,1.8925-1.6172,3.2021l-.0019,2.4639,52.1249987,43.3545c1.6445,1.3681,3.7567999,2.0498,5.8671999,2.0537,2.1112999.0039,4.2245999-.6739,5.8719999-2.0362l55.3554986-45.749c-.0469-2.0742-1.6729-3.7598-3.7196999-3.918Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M1268.8579408 713.0383102l-.0098 3.1895c0 1.1055.4512 2.1055 1.1719 2.8408l43.2782989-35.7656-4.2196999-3.5088-40.220699 33.2441zM1344.8637578 679.8528102l-4.2246188 3.4922 44.4257989 36.9521c1.7246-.456 3.0116999-2.0205 3.0184999-3.8867l-.0039-.6162-43.21578-35.9414z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m1401.6557578,639.4212102c.1718796-8.503-6.5791202-15.5362-15.082-15.7129-8.5039198-.1719-15.5381196,6.5781-15.7139196,15.0839-.1758,8.504,6.5790998,15.5391,15.0829996,15.7129,8.50292.1739,15.5380996-6.582,15.71292-15.0839Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f5f5",
    d: "m1385.1235379,645.5120102c-.5342-.0127-1.0401-.2373-1.4092-.6221l-5.0263999-5.2363c-.7705-.8028-.748-2.0762.0567-2.8467.8017-.7686,2.0751999-.7451,2.8456999.0586l3.6346999,3.7851,7.5488998-7.247c.8007-.7696,2.0780999-.7442,2.8446999.0586.7725.8027.7461202,2.0742-.0596,2.8447l-9.0009998,8.6426c-.3828.3681-.8994.5713-1.4345.5625Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m482.0395578,728.0784102c-32.3545.0537-58.7251-26.2334-58.773-58.5889-.0532-32.3574,26.231-58.7207,58.586-58.7724,32.354-.0538,58.7226,26.2285,58.7773,58.5859.0523,32.3564-26.2353,58.7236-58.5903,58.7754Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14b6c8",
    d: "m481.8637578,618.2571102c-28.1992.0459-51.1016,23.0225-51.0557,51.2217.0455,28.2002,23.0201,51.1035,51.2227,51.0595,28.1968-.0439,51.1035-23.0234,51.0576-51.2246-.0429-28.1992-23.0244-51.1015-51.2246-51.0566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "m481.8637578,618.2571102h0c-28.1992.0459-51.1016,23.0225-51.0557,51.2217.0455,28.2002,23.0201,51.1035,51.2227,51.0595h0c-15.9692.0264-28.9971-22.8984-29.041-51.0957-.0449-28.1972,12.9082-51.1601,28.874-51.1855Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m486.7817578,669.3889102c-.0044-2.6679-2.1719-4.8301-4.8438-4.8232-2.6689.0039-4.8252,2.1719-4.8242,4.8418.0044,2.6699,2.1719,4.8271,4.8433,4.8222,2.6694-.0058,4.8266-2.1718,4.8247-4.8408Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m494.2241578,684.8157102c-.3662,0-.732-.1524-.9932-.4492l-12.2749-14.1075c-.2065-.2373-.3213-.5449-.3213-.8603l-.0542-34.7451c-.0024-.7246.585-1.3145,1.312-1.3164.7251,0,1.3125.5869,1.3125,1.3095l.0567,34.2588,11.9541,13.7344c.4741.5459.4184,1.3779-.1289,1.8516-.25.2187-.5538.3242-.8628.3242Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m456.6606578,691.6008102c-.188,0-.3726-.0781-.5039-.2324-.2344-.2754-.2012-.6865.0757-.9248l25.291-21.5439c.2793-.2364.6894-.2032.9243.0732.2358.2764.2012.6895-.0737.9248l-25.2906,21.5449c-.1225.1075-.2758.1582-.4228.1582Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M481.8705578 621.3147102c-.7265 0-1.3134.5908-1.3105 1.3135v.3672l.0024 1.9736.0025.3623c.001.7256.5869 1.3145 1.3144 1.3125.7242-.001 1.3111-.5898 1.3111-1.3125l-.001-.3672-.0034-1.9736.001-.3643c-.002-.7275-.5914-1.3134-1.3165-1.3115zM482.0151578 712.1516102c-.7241.001-1.3101.5889-1.3101 1.3145l.002.3672v1.9726l.0024.3662c.002.7237.5894 1.3116 1.3154 1.3096.7266 0 1.3125-.5908 1.3116-1.3164v-.3623l-.0049-1.9746v-.3643c-.001-.7265-.5903-1.3135-1.3164-1.3125z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M469.7294578 624.0911102c-.2881.0801-.4619.3769-.3838.667l.0411.1435.4238 1.5713.042.1436c.0737.291.3716.4629.6606.3828.2925-.0772.4605-.375.3838-.6612l-.04-.1474-.4204-1.5703-.0435-.1465c-.0752-.291-.3735-.46-.6636-.3828zM493.3808578 711.7942102c-.2891.0801-.4604.377-.3813.666l.04.1465.4238 1.5713.0366.1435c.0791.2891.377.459.6661.3809.2895-.0762.457-.375.3803-.6641l-.0376-.1445-.4228-1.5703-.0401-.1465c-.0776-.2881-.3735-.459-.665-.3828z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M448.7143578 636.2698102c-.21.2139-.208.5547 0 .7685l.1079.1045 1.1524 1.1514.1064.1016c.2104.2138.5542.2109.7651 0 .2159-.211.2129-.5557 0-.7657l-.1054-.1074-1.1534-1.1455-.1064-.1074c-.2114-.2149-.5542-.2139-.7666 0zM513.0488578 700.3997102c-.211.2129-.211.5556 0 .7656l.1059.1074 1.1524 1.1465.1074.1094c.2139.209.5552.209.7676-.003.2114-.2109.2099-.5556 0-.7666l-.1079-.1093-1.1524-1.1465-.1064-.1055c-.2149-.2109-.5572-.2109-.7666.002z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M436.6010578 657.3255102c-.0757.289.0967.5859.3858.664l.1469.0391 1.5703.4179.1446.0391c.289.0781.5874-.0967.664-.3838.0801-.29-.0947-.5888-.3838-.666l-.1445-.0371-1.5747-.417-.1426-.04c-.2924-.0772-.5869.0947-.666.3838zM524.3828578 680.6965102c-.0777.2872.0966.5821.3847.6612l.1436.039 1.5747.42.1435.0361c.2891.0781.587-.0898.6641-.3838.0776-.29-.0957-.585-.3848-.6631l-.146-.0371-1.5703-.418-.1469-.039c-.2881-.0801-.586.0937-.6626.3847z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M436.6435578 681.6165102c.0776.289.3745.459.6616.3808l.148-.0371 1.5678-.4267.149-.0391c.2861-.0772.4585-.3721.3828-.6641-.0791-.289-.3784-.459-.666-.3818l-.147.041-1.5703.4209-.1426.0401c-.291.0781-.4624.3769-.3833.666zM524.3437578 657.9641102c.0815.2881.3784.461.665.3809l.147-.0391 1.5713-.4238.1426-.0381c.291-.0752.4624-.375.3823-.6641-.0776-.29-.3745-.4599-.6636-.3828l-.145.0381-1.5688.4248-.147.0401c-.2881.0781-.4595.375-.3838.664z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M448.8198578 702.6321102c.2129.2109.5561.209.7685-.0049l.1045-.1016 1.148-1.1543.1079-.1064c.2114-.2129.2099-.5566-.0034-.7676-.2115-.2129-.5528-.209-.7652.002l-.1079.1054-1.1455 1.1514-.1069.1084c-.21.2149-.211.5537 0 .7676zM512.9521578 638.2962102c.2104.2119.5517.2089.7651 0l.107-.1075 1.1455-1.1523.1079-.1055c.2124-.2129.2099-.5556-.001-.7676-.2129-.2119-.5562-.2089-.7676 0l-.1045.1094-1.1499 1.1504-.1045.1074c-.2138.211-.2158.5547.002.7657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M469.8784578 714.7424102c.289.0782.5815-.0947.6616-.3837l.039-.1456.417-1.5693.0401-.1475c.0766-.289-.0957-.5869-.3848-.663-.2895-.0762-.5874.0937-.6616.3847l-.0415.1465-.417 1.5693-.0376.1446c-.0781.291.0923.5849.3848.664zM493.2465578 626.9622102c.2881.0761.5869-.0948.6607-.3828l.04-.1456.419-1.5712.0366-.1465c.0781-.2891-.0908-.583-.3814-.6621-.2925-.0801-.5884.0957-.666.3838l-.0391.1455-.416 1.5713-.04.1445c-.0786.29.0957.5869.3862.6631z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M457.8359578 627.7962102c-.625.3613-.8384 1.1679-.4737 1.791l.1812.3154.9888 1.71.1836.3154c.3628.6279 1.1679.8389 1.7973.4775.626-.3633.8394-1.166.4781-1.7949l-.1836-.3144-.9908-1.709-.1826-.3164c-.3633-.627-1.1675-.8418-1.7983-.4746zM503.3832578 706.3899102c-.6279.3633-.8393 1.168-.478 1.7959l.1821.3154.9922 1.7051.1826.3184c.3633.6259 1.1656.8427 1.794.4756.6279-.3633.8437-1.1641.477-1.792l-.1845-.3155-.9878-1.7099-.1826-.3174c-.3633-.6231-1.1651-.8399-1.795-.4756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M440.2680578 645.4231102c-.3603.627-.146 1.4326.4834 1.7969l.3169.1797 1.7095.9834.3169.1806c.6264.3594 1.4301.1446 1.7929-.4834.3623-.6298.149-1.4287-.4829-1.7929l-.3144-.1827-1.7139-.9843-.3149-.1817c-.627-.3613-1.4312-.1435-1.7935.4844zM519.0068578 690.7141102c-.3618.627-.1446 1.4346.4824 1.7949l.3159.1797 1.7139.9864.3144.1816c.6285.3604 1.4327.1445 1.793-.4844.3638-.6269.147-1.4306-.4849-1.7949l-.3134-.1797-1.7105-.9853-.3169-.1787c-.6318-.3633-1.4316-.1485-1.7939.4804z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M433.8642578 669.4739102c.001.7285.5903 1.3144 1.3169 1.3144l.3647-.0019 1.9727-.0059h.3647c.7266 0 1.3116-.5888 1.3101-1.3144 0-.7246-.5884-1.3106-1.3154-1.3106h-.3658l-1.9697.0039h-.3662c-.7261.002-1.3144.5899-1.312 1.3145zM524.6996578 669.3274102c.0025.7256.5918 1.3135 1.3169 1.3135l.3638-.001 1.9751-.0039h.3648c.727 0 1.312-.5898 1.312-1.3174-.001-.7236-.5904-1.3115-1.3164-1.3076h-.3648l-1.9731.002-.3648.0019c-.726.002-1.3135.5889-1.3135 1.3125z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M440.3422578 693.5071102c.3648.6279 1.169.8398 1.7974.4775l.3144-.1826 1.7061-.9892.3184-.1836c.6284-.3643.8427-1.1651.477-1.795-.3638-.6279-1.1655-.8447-1.7964-.4785l-.3135.1826-1.707.9903-.3179.1836c-.6254.3633-.8398 1.166-.4785 1.7949zM518.9399578 647.9602102c.3647.627 1.1665.8438 1.7915.4785l.3183-.1816 1.7061-.9902.3159-.1817c.627-.3652.8428-1.168.478-1.7988-.3613-.6231-1.1665-.8379-1.7915-.4746l-.3173.1826-1.7071.9883-.3154.1845c-.6299.3653-.8423 1.167-.4785 1.793z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M457.9731578 711.0764102c.6294.3633 1.4302.1475 1.7934-.4804l.1802-.3184.9868-1.71.1802-.3164c.3604-.6289.1465-1.4326-.4839-1.7929-.6284-.3623-1.4311-.1485-1.7929.4814l-.1802.3174-.9863 1.7129-.1792.3144c-.3648.628-.1465 1.4317.4819 1.792zM503.2656578 632.3372102c.6294.3633 1.4311.1445 1.7939-.4805l.1812-.3164.9853-1.7129.1812-.3174c.3603-.6299.1435-1.4306-.4849-1.792-.6269-.3613-1.4311-.1455-1.7949.4844l-.1802.3145-.9863 1.7109-.1812.3164c-.3603.6309-.1435 1.4336.4859 1.793z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "m521.9482578,493.1028102c-2.209,0-4,1.791-4,4v50c0,2.209,1.791,4,4,4s4-1.791,4-4v-50c0-2.209-1.791-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "m521.9482578,559.1028102c-2.209,0-4,1.791-4,4v5.251c0,2.209,1.791,4,4,4s4-1.791,4-4v-5.251c0-2.209-1.791-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "m1290.7934402,389.5720102c-60.8319985-10.5683-118.467797-26.8144-171.3056824-48.289-50.662112-20.5918-97.3203108-46.084-138.6787097-75.7676-26.7352903-19.1885-50.9266987-39.9102-71.9012903-61.5879-.7539079-.7793-1.7911079-1.2187-2.875-1.2187-1.084,0-2.1211078.4394-2.875,1.2187-20.9776073,21.6797-45.17,42.4014-71.903406,61.5879-41.360299,29.6855-88.0184978,55.1768-138.680594,75.7676-52.8418,21.4746-110.4795,37.7226-171.3101,48.289-1.9165.3321-3.3154,1.9961-3.3154,3.9405v87.5903c0,2.209,1.791,4,4,4s4-1.791,4-4v-84.2319c60.17332-10.6739,117.228-26.877,169.6371975-48.1778,51.2460987-20.8271,98.4608975-46.625,140.3329965-76.6777,25.9101993-18.5957,49.4804988-38.627,70.1143061-59.5801,20.6317916,20.9522,44.201091,40.9824,70.1122904,59.5801,41.8700989,30.0508,89.0838977,55.8496,140.3309965,76.6777,52.4052987,21.2998,109.4579972,37.502,169.6327957,48.1778v113.0854c0,2.209,1.791,4,3.9999999,4s3.9999999-1.791,3.9999999-4v-116.4438c0-1.9444-1.3994-3.6084-3.3153999-3.9405Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "m1290.1088403,577.9563102c-2.2089999,0-3.9999999,1.791-3.9999999,4v8c0,2.209,1.791,4,3.9999999,4s3.9999999-1.791,3.9999999-4v-8c0-2.209-1.791-4-3.9999999-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "m1290.1088403,521.9563102c-2.2089999,0-3.9999999,1.791-3.9999999,4v40c0,2.209,1.791,4,3.9999999,4s3.9999999-1.791,3.9999999-4v-40c0-2.209-1.791-4-3.9999999-4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "m1290.1088403,767.1995102c-2.2089999,0-3.9999999,1.791-3.9999999,4v10c0,2.209,1.791,4,3.9999999,4s3.9999999-1.791,3.9999999-4v-10c0-2.209-1.791-4-3.9999999-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "m1290.1088403,844.1995102c-2.2089999,0-3.9999999,1.791-3.9999999,4v26.9521c0,11.8565-.9668,24.0264-2.8729999,36.1709-1.7998,11.4649-4.4706999,23.1162-7.9384998,34.6299-31.7899992,105.5684-122.2577969,186.2637-173.3544956,224.9697-83.1014979,62.9463-159.807596,91.6162-195.9100872,91.6162-22.4903073,0-57.75-10.9326-96.7393054-29.9961-44.1181989-21.5712-90.5937977-52.5439-130.8651946-87.2119-43.0762-37.0849-119.0752-113.3554-144.0801-207.4941l-.0005-.001c-3.3677-12.6806-5.7515-25.4765-7.0855-38.0351-.872-8.211-1.3139-16.5039-1.3139-24.6485v-24.6611c0-2.209-1.791-4-4-4s-4,1.791-4,4v24.6611c0,8.4258.457,17.003,1.3589,25.4942,1.3769,12.9648,3.8359,26.1679,7.3091,39.2431,11.1303,41.9053,32.9946,84.2891,64.98482,125.9727,28.55668,37.209,60.14058,67.0498,81.60838,85.5312,40.774397,35.1016,87.8554958,66.4737,132.5703,88.3369,40.0458937,19.5791,76.586,30.8086,100.253,30.8086,37.3973912,0,116.1668892-29.1777,200.7401871-93.2392,51.8729987-39.294,143.7401964-121.2998,176.1845955-229.0401,3.5722174-11.8623,6.3252174-23.872,8.1805998-35.6962,1.9717-12.5538,2.9706999-25.1407,2.9706999-37.4112v-26.9521c0-2.209-1.791-4-3.9999999-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "m1290.1088403,793.1995102c-2.2089999,0-3.9999999,1.791-3.9999999,4v35c0,2.209,1.791,4,3.9999999,4s3.9999999-1.791,3.9999999-4v-35c0-2.209-1.791-4-3.9999999-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "m521.9482578,782.4905102c2.209,0,4-1.791,4-4v-8c0-2.209-1.791-4-4-4s-4,1.791-4,4v8c0,2.209,1.791,4,4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "m521.9482578,838.4905102c2.209,0,4-1.791,4-4v-40c0-2.209-1.791-4-4-4s-4,1.791-4,4v40c0,2.209,1.791,4,4,4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M481.9482578 573.7171102c-2.209 0-4 1.791-4 4v8c0 2.2089 1.791 4 4 4s4-1.7911 4-4v-8c0-2.209-1.791-4-4-4zM481.9482578 517.7171102c-2.209 0-4 1.791-4 4v40c0 2.2089 1.791 4 4 4s4-1.7911 4-4v-40c0-2.209-1.791-4-4-4zM1342.5307578 602.6858102h-8.4219187v-243.4497c0-2-1.4775-3.6934-3.4598999-3.9629-159.114296-21.6894-265.1835933-78.3096-326.1454918-121.9883-66.0449983-47.3203-94.8544976-90.0713-95.1367976-90.4961-.7412-1.1172-1.9920999-1.7871-3.3319999-1.7881h-.0028921c-1.3389078 0-2.5899078.6709-3.3321078 1.7872-.2832.4257-29.0926993 43.1767-95.1385976 90.497-60.9628985 43.6787-167.0341946 100.2989-326.1528946 121.9883-1.9824.2695-3.4599 1.9629-3.4599 3.9629v146.481c0 2.2089 1.791 4 4 4s4-1.7911 4-4v-142.9957c69.7593-9.7724 135.2036-26.9541 194.5766-51.0849 48.3261966-19.6406 92.7607955-43.9043 132.0712945-72.1182 55.0616055-39.5185 84.1308979-75.1494 93.4366055-87.6377 9.3055919 12.4883 38.375 48.1192 93.4354898 87.6377 39.309599 28.2139 83.7431979 52.4776 132.0683967 72.1182 59.3711135 24.1308 124.8143968 41.3125 194.5721951 51.0849v239.9644h-8.4217998c-2.6386999 0-3.3818999 1.6299-1.6504 3.6211l10.9256997 12.5752c1.7305 1.9892 4.5615999 1.9892 6.2919998 0l10.9267997-12.5752c1.7305-1.9912.9863-3.6211-1.6503811-3.6211z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "m1126.0942444,1202.8069102c-78.750998,59.6523-167.1874866,99.731425-220.0614866,99.731425-61.5967063,0-168.293-53.367125-253.7012-126.894525-.7842-.6748-1.5801-1.3652-2.377-2.0586-.2617.5117-.5439,1.0117-.8584,1.4932-.1064.1758-.209.3535-.3222.5263-1.1358,1.7334-2.1856,3.3125-3.1778,4.7891.5049.4375,1.0157.8818,1.5157,1.3125,43.916,37.8076,92.7069963,70.2979,141.0985951,93.958,45.9960988,22.4893251,87.8397978,34.8740248,117.8223049,34.8740248,54.4813908,0,144.8592885-40.7314248,224.8924865-101.3545248,8.8339998-6.6914,18.7529995-14.5498,29.3290993-23.5029-1.2734-2.2588-2.5409999-4.5517-3.9208999-7.164-10.9217997,9.288-21.1620995,17.414-30.2391992,24.29Zm-640.1459866-327.6553v-111.9023h8.4219c2.6377,0,3.3813-1.6299,1.6503-3.6211l-10.9262-12.5752c-1.7305-1.9893-4.5615-1.9893-6.292,0l-10.9263,12.5752c-1.7309,1.9912-.9873,3.6211,1.6504,3.6211h8.4219v111.9023c0,94.3701,48.147,176.0772,98.8823,235.9766-1.7837-5.9317-3.4414-12.1406-4.9111-18.5781-45.5235-57.2891-85.9712-132.1719-85.9712-217.3985Zm844.1605814-109.25c-2.2089999,0-3.9999999,1.791-3.9999999,4v50c0,2.209,1.791,4,3.9999999,4s3.9999999-1.791,3.9999999-4v-50c0-2.209-1.791-4-3.9999999-4Zm0,65c-2.2089999,0-3.9999999,1.791-3.9999999,4v40.25c0,27.0674-4.2089999,54.7686-12.5106997,82.334-19.2245995,63.8399-57.2089986,118.9033-96.6650976,162.4883-2.3983999,6.7334-4.9452843,13.3594-7.4862843,19.706,44.6884834-46.3017,90.0126822-107.497,111.8114817-179.8877,8.5273998-28.3144,12.8505997-56.7919,12.8505997-84.6406v-40.25c0-2.209-1.791-4-3.9999999-4Zm0-89.4492c-2.2089999,0-3.9999999,1.791-3.9999999,4v8.4492c0,2.209,1.791,4,3.9999999,4s3.9999999-1.791,3.9999999-4v-8.4492c0-2.209-1.791-4-3.9999999-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001f3e",
    d: "M485.9482578 875.1516102v-111.9023h8.4219c2.6377 0 3.3813-1.6299 1.6503-3.6211l-10.9262-12.5752c-1.7305-1.9893-4.5615-1.9893-6.292 0l-10.9263 12.5752c-1.7309 1.9912-.9873 3.6211 1.6504 3.6211h8.4219v111.9023c0 94.3701 48.147 176.0772 98.8823 235.9766-1.7837-5.9317-3.4414-12.1406-4.9111-18.5781-45.5235-57.2891-85.9712-132.1719-85.9712-217.3985zM1330.1088392 830.9016102c-2.2089999 0-3.9999999 1.791-3.9999999 4v40.25c0 27.0674-4.2089999 54.7686-12.5106997 82.334-19.2245995 63.8399-57.2089986 118.9033-96.6650976 162.4883-2.3983999 6.7334-4.9452843 13.3594-7.4862843 19.706 44.6884834-46.3017 90.0126822-107.497 111.8114817-179.8877 8.5273998-28.3144 12.8505997-56.7919 12.8505997-84.6406v-40.25c0-2.209-1.791-4-3.9999999-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m1126.0942444,1202.8069102c-38.175799,28.917-78.626998,53.2344-116.2001971,70.6162l5.9677998,5.9678c37.4315991-17.5479,77.392498-41.6729,115.0633971-70.2071,8.8339998-6.6914,18.7529995-14.5498,29.3290993-23.5029-1.2734-2.2588-2.5409999-4.5517-3.9208999-7.164-10.9217997,9.288-21.1620995,17.414-30.2391992,24.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "m1320.4955395,930.0276102c-1.8486,9.1494-4.1424999,18.3105-6.8973998,27.458-19.2245995,63.8399-57.2089986,118.9033-96.6650976,162.4883-2.3983999,6.7334-4.9452843,13.3594-7.4862843,19.706,44.6884834-46.3017,90.0126822-107.497,111.8114817-179.8877,2.3085999-7.665,4.2978999-15.3417,5.9872998-23.0146l-6.7499998-6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "m649.9545578,1173.5852102c-.2617.5117-.5439,1.0117-.8584,1.4932-.1064.1758-.209.3535-.3222.5263-1.1358,1.7334-2.1856,3.3125-3.1778,4.7891.5049.4375,1.0157.8818,1.5157,1.3125,43.916,37.8076,92.7069963,70.2979,141.0985951,93.958,4.0399999,1.9756,8.0458998,3.8682,12.0165997,5.6856l6.0370998-6.0371c-50.0722987-22.6709-105.4335973-57.9161-153.9325947-99.669-.7842-.6748-1.5801-1.3652-2.377-2.0586Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "m492.5439578,935.0354102l-6.6792,6.6797c15.6963,66.3096,52.5869,124.1025,90.9658,169.4131-1.7837-5.9317-3.4414-12.1406-4.9111-18.5781-34.5196-43.4414-66.1153-97.001-79.3755-157.5147Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolveDigitalSecurity);
export default __webpack_public_path__ + "static/media/solve-digital-security.31dc2701d2ba50de04d7aaa9b709963a.svg";
export { ForwardRef as ReactComponent };